import CloseIcon from "@mui/icons-material/Close";
import { Box, IconButton, Stack } from "@mui/material";
import { isNil, sortBy } from "lodash";
import React, { useEffect, useMemo } from "react";
import Select, { type SingleValue } from "react-select";
import { useTerminalsForInternalLazyQuery } from "../../generated/graphql";

const TerminalSelect = ({
  companyUuid,
  currentTerminalUuid,
  setTerminalUuid,
  showLabel = false,
}: {
  readonly companyUuid: string | null | undefined;
  readonly currentTerminalUuid: string | null | undefined;
  readonly setTerminalUuid: (uuid: string | null) => void;
  readonly showLabel?: boolean;
}) => {
  const [getCompanyTerminals, { data: terminalsData }] =
    useTerminalsForInternalLazyQuery({
      fetchPolicy: "cache-first",
    });

  useEffect(() => {
    if (!isNil(companyUuid)) {
      getCompanyTerminals({
        variables: {
          getTerminalsInternalInput: {
            companyUuid,
            excludeNotActive: false,
          },
        },
      });
    }
  }, [companyUuid]);

  const terminalOptions = useMemo(
    () =>
      sortBy(terminalsData?.terminalsForInternal, (t) => t.code).map(
        (terminal) => ({
          value: terminal.uuid,
          label: `${terminal.code}${terminal.isActive ? "" : " (archived)"}`,
        }),
      ),
    [terminalsData],
  );

  const currentOption = terminalOptions?.find(
    (option) => option.value === currentTerminalUuid,
  );

  return (
    <div>
      {showLabel && <div>Select terminal</div>}
      <Stack direction="row" spacing={0.5}>
        <Select
          menuPosition="fixed"
          options={terminalOptions}
          placeholder="Select terminal"
          value={currentOption ?? null}
          onChange={(option: SingleValue<{ label: string; value: string }>) => {
            if (!isNil(option) && !isNil(option.value)) {
              setTerminalUuid(option.value);
            }
          }}
        />
        <Box>
          {!isNil(currentOption) && (
            <IconButton
              size="small"
              onClick={() => {
                setTerminalUuid(null);
              }}
            >
              <CloseIcon />
            </IconButton>
          )}
        </Box>
      </Stack>
    </div>
  );
};

export default TerminalSelect;
